module.exports = __webpack_public_path__ + "img/0195604474592f55e1128df7e649874b.svg";